import { Tooltip } from "@material-ui/core";
import CopySvgComponent from "assets/icons/svg/copy";
import { InputField } from "components";
import { AlertMessage } from "components/AlertMessage";
import DividerComponent from "components/Divider";
import { Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { emailRegex } from "utils/validation";
import MyButton from "../../components/MyButton";

const InviteMember = () => {
  const orgDetails = JSON.parse(localStorage.getItem("organization"));
  const textAreaRef = useRef(null);
  const [copysuccess, setCopySuccess] = useState(false);
  const copySuccess = `https://${orgDetails?.orgkey}.${process.env.REACT_APP_SUBDOMAIN}`;

  useEffect(() => {
    const timer = setTimeout(() => {
      setCopySuccess(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [copysuccess]);

  return (
    <div className="invitation">
      {copysuccess ? (
        <AlertMessage type="success" content="URL Copied Successfully" />
      ) : (
        ""
      )}
      <div>
        <p className="invitation-header">Invite a Member</p>
      </div>
      <div className="invite-input">
        <Formik
          initialValues={{ email: "", url: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.email) {
              errors.email = "Required";
            } else if (
              !emailRegex.test(values.email)
            ) {
              errors.email = "Invalid email address";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              alert(JSON.stringify(values, null, 2));
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            /* and other goodies */
          }) => (
            <div>
              <InputField
                handleChange
                mandatory={true}
                {...{
                  title: "Phone Number/Email Address",
                  name: "email",
                  placeholder: "Email/Phone here...",
                  checkValidation: true,
                }}
              />
              {errors.email}
              <div className="send-invitation">
                <MyButton
                  type={"primary"}
                  content={"Send Invitation"}
                  onClick={() => handleSubmit}
                />
              </div>
              <DividerComponent />
              <p className="input-head">Copy Invitation Link</p>
              <div className="input-data">
                <div className="input-text" ref={textAreaRef}>
                  {copySuccess}
                </div>
                <div className="copy-svg">
                  <Tooltip title="Copy Link">
                    <CopyToClipboard text={copySuccess}>
                      <CopySvgComponent onClick={() => setCopySuccess(true)} />
                    </CopyToClipboard>
                  </Tooltip>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default InviteMember;
